import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ParametrizacionEmpleadoService} from "../../services/parametrizacion-empleado.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {ModalService} from "../../services/modal.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ParametrizacionReemplazoEmpleadoService} from "../../services/parametrizacion-reemplazo-empleado.service";


@Component({
  selector: 'app-parametrizacion-reemplazo-empleados',
  templateUrl: './parametrizacion-reemplazo-empleados.component.html',
  styleUrls: ['./parametrizacion-reemplazo-empleados.component.css']
})
export class ParametrizacionReemplazoEmpleadosComponent implements OnInit {
  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  labelEmpleadoInfo: any;
  labelReemplazoInfo: any;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionEmpleado: ParametrizacionEmpleadoService,
    private _parametrizacionReemplazoEmpleados: ParametrizacionReemplazoEmpleadoService,
    private _util: UtilsService,
    private _modalService: ModalService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionReemplazoEmpleados;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.formulario = this.fb.group({
      id: [''],
      cedulaEmpleado: ['', [Validators.required]],
      cedulaReemplazo: ['', [Validators.required]],
      nombreEmpleado: [''],
      nombreReemplazo: [''],
    });
    this.girdComponent();
    this.getAllReemplazoEmpleados();
    this._modalService.getModalEvent().subscribe(data => {
      if (data && data.data) {
        this.formulario.get(data.inputInformation.formControl).setValue(data.data.cedula);
        if (data.inputInformation.formControl === 'cedulaEmpleado') {
          this.labelEmpleadoInfo = data.data.cedula + ' - ' + data.data.nombres;
        } else if (data.inputInformation.formControl === 'cedulaReemplazo') {
          this.labelReemplazoInfo = data.data.cedula + ' - ' + data.data.nombres;
        }
      }
    });
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.labelEmpleadoInfo = '';
    this.labelReemplazoInfo = '';
    this.formulario.reset();
  }

  getAllReemplazoEmpleados() {
    this.loading = true;
    this._parametrizacionReemplazoEmpleados.getAll().subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA EMPLEADO',
        field: 'cedulaEmpleado',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NOMBRE EMPLEADO',
        field: 'nombreEmpleado',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'CEDULA REEMPLAZO',
        field: 'cedulaReemplazo',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NOMBRE REEMPLAZO',
        field: 'nombreReemplazo',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarReemplazoEmpleado.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarReemplazoEmpleado({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.formulario.setValue(rowData);
    this.labelEmpleadoInfo = rowData.cedulaEmpleado + ' - ' + rowData.nombreEmpleado;
    this.labelReemplazoInfo = rowData.cedulaReemplazo + ' - ' + rowData.nombreReemplazo;
  }


  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._parametrizacionReemplazoEmpleados.borrarReemplazoEmpleado(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarReemplazoEmpleado();
      } else {
        this.guardarReemplazo();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  actualizarReemplazoEmpleado() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionReemplazoEmpleados.actualizarReemplazoEmpleado(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllReemplazoEmpleados();
      this.regresar();
    });
  }

  guardarReemplazo() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._parametrizacionReemplazoEmpleados.guardarReemplazoEmpleado(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllReemplazoEmpleados();
      this.regresar();
    });
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }


  openModalEmpleados(formControl) {
    document.getElementById('abrirModalEmpleado').click();
    const payload = {
      formControl
    }
    this._modalService.setModalInputInformation(payload);
  }


}
